// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-pages-reanim-30-jsx": () => import("./../../../src/pages/reanim30.jsx" /* webpackChunkName: "component---src-pages-reanim-30-jsx" */),
  "component---src-pages-vip-jsx": () => import("./../../../src/pages/vip.jsx" /* webpackChunkName: "component---src-pages-vip-jsx" */)
}

